import { Overrides } from '@material-ui/core/styles/overrides';

const overrides: Overrides = {
  MuiDialogContent: {
    root: {
      maxHeight: 'calc(95vh - 180px)'
    }
  },
  MuiButton: { root: { textTransform: 'none' } },
  MuiListItemIcon: {
    root: {
      minWidth: 32
    }
  },
  MuiListItem: {
    root: {
      paddingTop: 4,
      paddingBottom: 4,
    }
  },
  MuiPaper: {
    rounded: {
      borderRadius: 16
    }
  },
  MuiTab: {
    root: {
      maxWidth: 'unset'
    }
  },
  MuiTableCell: {
    root: {
      padding: 8
    }
  },
  MuiTablePagination: {
    selectRoot: {
      marginLeft: 8,
      marginRight: 8
    },
    actions: {
      marginLeft: 16
    }
  }
};

export default overrides;